import type { SVGProps } from 'react';
const DawnFlagWS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-WS_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-WS_svg__a)">
      <path fill="#E31F37" d="M0 0h22v16H0z" />
      <path
        fill="#083B9A"
        fillRule="evenodd"
        d="M-1.048 8.533h12.572v-9.6H-1.048z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m5.238 2.133-.74.221.217-.754-.217-.754.74.22.741-.22-.217.754.217.754zm0 5.334-.74.22.217-.754-.217-.754.74.22.741-.22-.217.754.217.755zM2.402 5.02l.741-.221.74.22-.216-.753.217-.755-.74.221-.742-.22.217.754zm5.455-.754-.74.22.217-.754-.217-.754.74.22.741-.22-.217.754.217.755zM6.81 5.6a.264.264 0 0 1-.262.267.264.264 0 0 1-.262-.267c0-.147.117-.267.262-.267s.262.12.262.267"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagWS;
